import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import SignIn from "../pages/Auth/SingIn";
import SignUp from "~/pages/Auth/SignUp";
import ForgetPassword from "~/pages/Auth/ForgetPassword";
import Confirmation from "~/pages/Auth/SignUp/Confirmation";
import EmployeesPassword from "~/pages/Auth/EmployeesPassword";

export const initialRoutes = [
  { path: "/", component: SignIn },
  { path: "/acessar", component: SignIn },
  { path: "/cadastro", component: SignUp },
  { path: "/recuperar-senha", component: ForgetPassword },
  { path: "/criar-senha", component: ForgetPassword },
  { path: "/confirmacao", component: Confirmation },
  { path: "/senha-funcionario", component: EmployeesPassword }
];

export const PublicRoutes = () => {
  return (
    <Switch>
      {initialRoutes.map((route, idx) => {
        return route.component ? (
          <Route
            exact
            key={idx}
            path={route.path}
            component={route.component}
          />
        ) : null;
      })}
      <Route path="*">
        <Redirect to="/acessar" />
      </Route>
    </Switch>
  );
};
